import { render, staticRenderFns } from "./header-nav-desktop.vue?vue&type=template&id=ab79b4ee&lang=pug&"
import script from "./header-nav-desktop.vue?vue&type=script&lang=js&"
export * from "./header-nav-desktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports